import axios from 'axios';

import {
	FETCH_APARTMENTS_PENDING,
	FETCH_APARTMENTS_FULFILLED,
	FETCH_APARTMENTS_FAILED,
	FETCH_NEWEST_APARTMENTS_PENDING,
	FETCH_NEWEST_APARTMENTS_FULFILLED,
	FETCH_NEWEST_APARTMENTS_FAILED,
	SET_FILTERED_APARTMENTS_FULFILLED
} from '../constants/apartments.actions';
import { BASE_API_URL } from '../constants/urls';
import { filterApartments } from '../helpers/filters/filters';

export const fetchApartmentsPending = () => {
	return {
		type: FETCH_APARTMENTS_PENDING,
		payload: null
	};
};

export const fetchApartmentsFulfilled = (apartments) => {
	return {
		type: FETCH_APARTMENTS_FULFILLED,
		payload: {
			apartments
		}
	};
};

export const fetchApartmentsFailed = (status) => {
	return {
		type: FETCH_APARTMENTS_FAILED,
		payload: {
			status
		}
	};
};

export const fetchNewestApartmentsPending = () => ({
	type: FETCH_NEWEST_APARTMENTS_PENDING,
	payload: null
});

export const fetchNewestApartmentsFulfilled = apartments => ({
	type: FETCH_NEWEST_APARTMENTS_FULFILLED,
	payload: {
		apartments
	}
});

export const fetchNewestApartmentsFailed = () => ({
	type: FETCH_NEWEST_APARTMENTS_FAILED,
	payload: null
});

export const fetchApartments = (type) => {
	return async function(dispatch) {
		dispatch(fetchApartmentsPending());

		const query = type ? `?type=${type}` : ``
		try {
			const response = await axios(`${BASE_API_URL}/apartments${query}`);
			dispatch(fetchApartmentsFulfilled(response.data));
		} catch(error) {
			dispatch(fetchApartmentsFailed(500));
		}
	};
};

export const fetchNewestApartments = (type) => {
	return async function(dispatch) {
		dispatch(fetchNewestApartmentsPending());

		const query = type ? `?type=${type}` : ``
		try {
			// TODO: Fetch newest apartments and not just the apartments
			const response = await axios(`${BASE_API_URL}/apartments${query}`);
			dispatch(fetchNewestApartmentsFulfilled(response.data.slice(0, 3)));
		} catch(error) {
			dispatch(fetchNewestApartmentsFailed(500));
		}
	};
};

export const setFilteredApartments = (filters) => {
	return (dispatch, getState) => {
		const { apartments } = getState().apartmentsReducer;
		const filteredApartments = filterApartments(filters, apartments);

		dispatch({
			type: SET_FILTERED_APARTMENTS_FULFILLED,
			payload: {
				apartments: filteredApartments
			}
		});
	};
};
